/**
 * @classdesc Classe utilitária para agrupar métodos de manipulação de Erros.
 */
export default class ErrorUtil {
    static MSG_ERRO_PADRAO = 'Erro inesperado.';

    /**
     * Retorna uma mensagem de erro tratada.
     *
     * @public
     * @static
     * @param {Error | string | unknown} error Uma instância do objeto Error ou uma mensagem de erro (String).
     * @returns {string} A mensagem de erro tratada.
     */
    static montarMensagemErro(error) {
        if (!error) {
            return ErrorUtil.MSG_ERRO_PADRAO;
        }

        if (typeof error === 'string') {
            return error;
        }

        let msgErro = '';

        if (typeof error === 'object') {
            // @ts-ignore
            if (error.name && error.name !== 'Error') {
                // @ts-ignore
                msgErro += error.name + ': ';
            }

            // @ts-ignore
            if (error.message) {
                // @ts-ignore
                msgErro += error.message;
            }

            // @ts-ignore
            if (error.cause?.message) {
                // @ts-ignore
                msgErro += ` (causa: ${error.cause.message})`;
            }

            msgErro = msgErro.trim();
        }

        if (msgErro.length === 0) {
            msgErro = ErrorUtil.MSG_ERRO_PADRAO;
        }

        return msgErro;
    }

    static getMensagemErroServico(respostaServico) {
        if (respostaServico) {
            let responseData = Array.isArray(respostaServico.data) ? respostaServico.data[0] : respostaServico.data;

            if (responseData) {
                if (responseData.mensagem) {
                    let mensagem = responseData.mensagem.trim();

                    if (responseData.causaRaiz && responseData.causaRaiz.indexOf(mensagem) === -1) {
                        mensagem += ` (causa: ${responseData.causaRaiz})`;
                    }

                    return mensagem;
                }

                if (responseData.mensagens) {
                    return responseData.mensagens.map((mensagem) => mensagem).join('\n');
                }

                if (typeof responseData === 'string') {
                    responseData = responseData.trim();
                    return responseData;
                }
            }
        }

        return '';
    }

    static getMensagemErro(error) {
        if (typeof error === 'string') {
            return error;
        }

        let msgErro = '';

        if (error.response) {
            msgErro = ErrorUtil.getMensagemErroServico(error.response);
        }

        if (msgErro.length === 0 && error.request) {
            msgErro = 'Falha na requisição';
            console.error(error.request);
        }

        if (msgErro.length === 0) {
            msgErro = ErrorUtil.montarMensagemErro(error);
        }

        return msgErro;
    }

    static getResultadoProcessamentoErroServico(respostaServico, numeroProcesso) {
        return {
            numeroProcesso: numeroProcesso,
            erro: true,
            mensagem: ErrorUtil.getMensagemErroServico(respostaServico)
        };
    }

    static getResultadoProcessamentoErro(error, numeroProcesso) {
        return {
            numeroProcesso: numeroProcesso,
            erro: true,
            mensagem: ErrorUtil.getMensagemErro(error)
        };
    }

    static isResultadoErro(resultado) {
        if (!resultado || typeof resultado !== 'object') {
            console.error('Resultado de processamento inválido.');
        }

        return !!(resultado.tipo === 'ERRO' || resultado.erro);
    }

    static extrairErrosLote(resultadoLote) {
        let erros = [];
        let lote = !resultadoLote ? [] : Array.isArray(resultadoLote) ? resultadoLote : [].concat(resultadoLote);
        for (const item of lote) {
            if (ErrorUtil.isResultadoErro(item)) {
                erros.push(item);
            }
        }
        return erros;
    }

    static extrairSucessosLote(resultadoLote) {
        let sucessos = [];
        let lote;
        lote = !resultadoLote ? [] : Array.isArray(resultadoLote) ? resultadoLote : [].concat(resultadoLote);
        for (const item of lote) {
            if (!ErrorUtil.isResultadoErro(item)) {
                sucessos.push(item);
            }
        }
        return sucessos;
    }
    static montarResultadoProcessamentoLote(resultadoLote) {
        return resultadoLote?.map((item) => {
            let erro = ErrorUtil.isResultadoErro(item);
            return {
                numeroProcesso: item.elemento,
                erro: erro,
                mensagem: item.mensagem ? item.mensagem : erro ? 'ERRO' : 'SUCESSO'
            };
        });
    }
}
